/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from '../../components/CopyToClipboard';
import { useVaultService } from '../../hooks/useVaultService';

const useStyles = makeStyles(() => ({
  root: {
    width: window.innerWidth > 560 ? '50%' : '100%',
    minHeight: window.innerWidth > 560 ? 0 : '100%',
    maxWidth: 527,
    minWidth: 317,
    background: '#fff',
    margin: '0 auto',
    borderRadius: window.innerWidth > 560 ? 10 : 0,
    boxShadow: '0px 1px 7px rgba(0, 0, 0, 0.15)',
    padding: 25,
  },
  modal: {
    overflow: 'auto',
    paddingTop: window.innerWidth > 560 ? '10vh' : 0,
    paddingBottom: window.innerWidth > 560 ? '10vh' : 0,
  },
  close: {
    color: '#C1C4C9',
    marginTop: 3,
    width: '100%',
    cursor: 'pointer',
  },
  title: {
    color: '#A6AAB0',
    marginTop: -20,
    fontSize: 18,
    marginLeft: 40,
    marginRight: 40,
    textAlign: 'center',
  },
  fieldsWrap: {
    marginTop: 30,
    paddingLeft: window.innerWidth > 560 ? 40 : 0,
    paddingRight: window.innerWidth > 560 ? 40 : 0,
    width: '100%',
    flexDirection: 'column',
  },
  row: {
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    paddingBottom: 10,
    paddingTop: 10,
  },
  lastRow: {
    width: '100%',
    paddingBottom: 10,
    paddingTop: 10,
  },
  rowTitle: {
    color: '#A6AAB0',
    fontSize: 16,
  },
  rowValue: {
    color: '#2E3542',
    fontSize: 16,
    minHeight: 43,
    hyphens: 'auto',
    maxWidth: '70%',
    wordBreak: 'break-all',
  },
  icon: { padding: 9, color: '#A6AAB0', width: 42 },
  linkText: { color: '#E41139', fontSize: 16, fontWeight: 'normal', textDecoration: 'underline', flex: 'auto' },
}));

const ViewContacts = (props) => {
  const classes = useStyles();
  const { currentVault } = useVaultService();
  const { t } = useTranslation();
  const { rowId, onClose, onEdit } = props;

  const currentRecContact = currentVault.rec_contact.find((item) => item.id === rowId);

  const hasHttp = currentRecContact.url ? currentRecContact.url.indexOf('http') > -1 : false;
  const link = hasHttp ? currentRecContact.url : `http://${currentRecContact.url}`;

  const init = () => {};

  useEffect(() => {
    init();
  }, []);

  return (
    <Modal className={classes.modal} open={true} onClose={() => onClose()}>
      <Box
        className={classes.root}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Box
          onClick={() => onClose()}
          className={classes.close}
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Close />
        </Box>
        <Box
          className={classes.title}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          id="view"
          alignItems="center"
        >
          {t('translation:commonPages:view')}
        </Box>
        <Box
          className={classes.description1}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          alignItems="center"
        >
          {t('translation:commonPages:contacts')}
        </Box>

        <Box className={classes.fieldsWrap} display="flex" justifyContent="flex-start" alignItems="center">
          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:firstName')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.name}
              <CopyToClipboard fromView text={currentRecContact.name} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:lastName')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.surname}
              <CopyToClipboard fromView text={currentRecContact.surname} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:patronymic')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.patron}
              <CopyToClipboard fromView text={currentRecContact.patron} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:phone')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.phone}
              <CopyToClipboard fromView text={currentRecContact.phone} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:email')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.email}
              <CopyToClipboard fromView text={currentRecContact.email} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:webSite')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <a href={link} target="_blank" rel="noreferrer" className={classes.linkText}>
                {currentRecContact.url}
              </a>
              <CopyToClipboard fromView text={currentRecContact.url} />
            </Box>
          </Box>

          <Box
            className={classes.row}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className={classes.rowTitle}>{t('translation:commonPages:messenger')}</Box>
            <Box
              className={classes.rowValue}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              {currentRecContact.messenger}
              <CopyToClipboard fromView text={currentRecContact.messenger} />
            </Box>
          </Box>

          {currentRecContact.desc && (
            <Box
              className={classes.lastRow}
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Box className={classes.rowTitle}>
                {t('translation:commonPages:desc')}
                <CopyToClipboard fromView text={currentRecContact.desc} />
              </Box>
              <Box
                className={classes.rowValue}
                style={{ maxWidth: '100%' }}
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                {currentRecContact.desc}
              </Box>
            </Box>
          )}
        </Box>
        <Box
          className={classes.passwordField}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          alignItems="center"
          mt={7}
          mb={5}
        >
          <Button style={{ marginRight: 20 }} onClick={() => onClose()} variant="outlined" color="primary">
            {t('translation:commonPages:cancel')}
          </Button>
          <Button variant="contained" onClick={() => onEdit()} color="primary">
            {t('translation:commonPages:edit')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewContacts;
